export default "__VITE_ASSET___ylV49xZ__"